import IMask from 'imask';

import { FormattedInputBuilder } from './common';

const YEAR = new Date().getFullYear();

const ExpirationDateBlocks = {
  MM: {
    mask: IMask.MaskedRange,
    from: 1,
    to: 12,
  },
  YY: {
    mask: IMask.MaskedRange,
    from: YEAR % 100,
    to: 99,
  },
};
export const CardExpirationDate = FormattedInputBuilder({
  mask: 'MM/YY',
  blocks: ExpirationDateBlocks,
  name: 'expirationDate',
  autoComplete: 'cc-exp',
  placeholder: 'Ay / Yıl',
  inputVariant: 'form',
});

const CVVBlocks = {
  cvv: {
    mask: IMask.MaskedRange,
    from: 0,
    to: 9999,
  },
};
export const CVV = FormattedInputBuilder({
  mask: 'cvv',
  blocks: CVVBlocks,
  name: 'cvv',
  autoComplete: 'cc-csc',
  placeholder: 'CVV Kodu',
  inputVariant: 'form',
});

export const CreditCardNumberMasks = {
  mask: [
    {
      mask: '0000 0000 0000 0000',
      startsWith: '4',
      lazy: true,
      cardType: 'VISA',
    },
    {
      mask: '0000 0000 0000 000',
      startsWith: '3',
      lazy: true,
      cardType: 'Amex',
    },
    {
      mask: '0000 0000 0000 0000',
      startsWith: '5',
      lazy: true,
      cardType: 'MASTERCARD',
    },
    {
      mask: '0000 0000 0000 0000',
      startsWith: '',
      lazy: true,
      country: 'OTHER',
    },
  ],
  dispatch: function (
    appended: string,
    dynamicMasked: { value: string; compiledMasks: { startsWith: string }[] }
  ) {
    const num = (dynamicMasked.value + appended).replace(/\D/g, '');
    return dynamicMasked.compiledMasks.find(function (m) {
      return num.indexOf(m.startsWith) === 0;
    });
  },
};

export const CardNumberInput = FormattedInputBuilder({
  ...CreditCardNumberMasks,
  blocks: {},
  name: 'cardNumber',
  autoComplete: 'cc-number',
  placeholder: 'Kart Numarası',
  inputVariant: 'form',
});
